import React, { useMemo } from 'react';

import { TiptapRichTextEditor } from 'components/DesignSystems/New/TiptapRichTextEditor';
import {
  useSitrepSectionImages,
  type SitrepSectionType,
} from 'components/DisasterGPT/hooks/useSitrepsV2';
import LayerAnalyticsSection from 'components/Reports/LayerAnalytics/LayerAnalyticsSection';
import { isLayerAnalyticsSection } from 'components/Reports/LayerAnalytics/layerAnalytics.utils';

type ReadOnlyReportsSectionDisplayProps = {
  section: SitrepSectionType;
};

const ReadOnlyReportsSectionDisplay: React.FC<
  ReadOnlyReportsSectionDisplayProps
> = ({ section }) => {
  const latestVersion = useMemo(
    () => section.section_versions?.[0],
    [section.section_versions]
  );

  const { data: sitrepImages } = useSitrepSectionImages(section.id);

  const sectionText = useMemo(
    () => latestVersion?.sitrep_section_text || '',
    [latestVersion?.sitrep_section_text]
  );

  if (isLayerAnalyticsSection(section)) {
    return <LayerAnalyticsSection section={section} readOnly />;
  }

  return (
    <div className="reports-section">
      <div className="reports-section__text">
        {sectionText ? (
          <TiptapRichTextEditor
            value={sectionText}
            readOnly
            showToolbar={false}
            minHeight="2rem"
            className="reports-section__html-content"
            normalizeMarkdown
            imageLibrary={sitrepImages || []}
          />
        ) : (
          <em className="text-muted">No content added yet</em>
        )}
      </div>
    </div>
  );
};

export default ReadOnlyReportsSectionDisplay;
